import styles from '@/interface/ui/_shared/util/spinner.module.css';

const Spinner: NextPage = () => {
  return <div className={styles.spinner}></div>;
};

export default Spinner;

import type { NextPage } from 'next';
